import ImageCard from '@components/common/ImageCard';
import { getDataUrl } from '@lib/utils';

const tournaments = [
  {
    image: 'chess/tournaments/thailand_champion.webp',
    title: 'Thailand International Champion',
    location: 'Bangkok, Thailand'
  },
  {
    image: 'chess/tournaments/shanghai_tournament.webp',
    title: 'Shanghai Tournament',
    location: 'Shanghai, China'
  },
  {
    image: 'chess/tournaments/national_chess_champion_dapitan_2024.webp',
    title: 'National Champion 2024',
    location: 'Dapitan, Philippines'
  },
  {
    image: 'chess/tournaments/national_champion_dapitan_under16.webp',
    title: 'Under-16 National Champion',
    location: 'Dapitan, Philippines'
  },
  {
    image: 'chess/tournaments/national_chess_championship_dapitan_2024.webp',
    title: 'National Championship',
    location: 'Dapitan, Philippines'
  },
  {
    image: 'chess/tournaments/national_champion_malolos_2022.webp',
    title: 'National Champion 2022',
    location: 'Malolos, Philippines'
  },
  {
    image: 'chess/tournaments/regional_champion_1.webp',
    title: 'Regional Championship',
    location: 'Philippines'
  },
  {
    image: 'chess/tournaments/regional_champion_2.webp',
    title: 'Regional Championship',
    location: 'Philippines'
  },
  {
    image: 'chess/tournaments/international_tournament.webp',
    title: 'International Tournament',
    location: 'International'
  },
  {
    image: 'chess/tournaments/thailand_tournament.webp',
    title: 'Thailand Tournament',
    location: 'Thailand'
  },
  {
    image: 'chess/tournaments/west_bengal_state_level.webp',
    title: 'West Bengal State Level',
    location: 'India'
  },
  {
    image: 'chess/tournaments/php_national_chess_venue.webp',
    title: 'National Championship Venue',
    location: 'Philippines'
  }
];

const TournamentsGallerySection = () => {
  return (
    <section className="py-16 sm:py-20 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: 'var(--color-theme-1)' }}>
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-12 sm:mb-16">
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold mb-4"
            style={{ color: 'var(--color-heading)' }}
          >
            Tournament Gallery
          </h2>
          <p
            className="text-lg max-w-2xl mx-auto"
            style={{ color: 'var(--color-subtle)' }}
          >
            Moments captured from national and international chess competitions across Asia.
          </p>
        </div>

        {/* Gallery Grid - Desktop: Multi-column grid, Mobile: Horizontal scroll */}
        <div className="hidden sm:grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {tournaments.map((tournament, index) => (
            <div
              key={index}
              className="group relative rounded-xl overflow-hidden border shadow-card transition-all duration-300 hover:shadow-card-hover hover:-translate-y-1"
              style={{
                backgroundColor: 'var(--color-card-bg)',
                borderColor: 'var(--color-card-border)'
              }}
            >
              {/* Image */}
              <div className="relative overflow-hidden">
                <ImageCard
                  src={getDataUrl(tournament.image)}
                  alt={tournament.title}
                  aspectRatio="aspect-square"
                  rounded={false}
                  shadow={false}
                  className="group-hover:scale-105 transition-transform duration-300"
                />
                {/* Overlay on hover */}
                <div
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4"
                  style={{
                    background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)'
                  }}
                >
                  <div className="text-white">
                    <h3 className="font-bold text-sm mb-1">{tournament.title}</h3>
                    <p className="text-xs opacity-90">{tournament.location}</p>
                  </div>
                </div>
              </div>

              {/* Info (visible on tablet) */}
              <div className="p-4 lg:hidden">
                <h3
                  className="font-bold text-sm mb-1"
                  style={{ color: 'var(--color-heading)' }}
                >
                  {tournament.title}
                </h3>
                <p
                  className="text-xs"
                  style={{ color: 'var(--color-muted)' }}
                >
                  {tournament.location}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile Horizontal Scroll */}
        <div className="sm:hidden overflow-x-auto scrollbar-hide -mx-4 px-4">
          <div className="flex gap-4 pb-4">
            {tournaments.map((tournament, index) => (
              <div
                key={index}
                className="flex-shrink-0 w-72 rounded-xl overflow-hidden border shadow-card"
                style={{
                  backgroundColor: 'var(--color-card-bg)',
                  borderColor: 'var(--color-card-border)'
                }}
              >
                {/* Image */}
                <div className="relative overflow-hidden">
                  <ImageCard
                    src={getDataUrl(tournament.image)}
                    alt={tournament.title}
                    aspectRatio="aspect-square"
                    rounded={false}
                    shadow={false}
                  />
                </div>

                {/* Info */}
                <div className="p-4">
                  <h3
                    className="font-bold text-sm mb-1"
                    style={{ color: 'var(--color-heading)' }}
                  >
                    {tournament.title}
                  </h3>
                  <p
                    className="text-xs"
                    style={{ color: 'var(--color-muted)' }}
                  >
                    {tournament.location}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TournamentsGallerySection;
